// extracted by mini-css-extract-plugin
export default {"payments":"pexQO0tavf95olj8mMWR"};